import React from "react";
import WorkHome from "./WorkHome";

function Work() {
  return <WorkHome title="Projetos" highlight="" />;
}

export default Work;
